export default "__VITE_ASSET__Dd3EHFGE__"